export default __webpack_public_path__ + "images/C5.cff2c48.png";